import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    data$,
    fetchDataFx,
    Gate,
    setConfirmEvent,
    setConfirmFx,
    setReviewEvent,
    setReviewFx,
} from './index';

data$
    .on(fetchDataFx.doneData, (_, data) => data)
    .on(setReviewFx.doneData, (_, data) => data)
    .on(setConfirmFx.doneData, (_, data) => data)
    .reset(Gate.close);
sample({
    clock: Gate.open,
    source: Gate.state,
    target: fetchDataFx,
});

sample({
    clock: setReviewEvent,
    target: setReviewFx,
});

sample({
    clock: setConfirmEvent,
    target: setConfirmFx,
});

[fetchDataFx, setReviewFx, setConfirmFx].forEach((fx) =>
    fx.fail.watch(({error}) => showRestError(error as RestError)),
);
